<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>

                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="short_text"
                                name="code"
                                v-model="form.code"
                                :label="$t('delivery.coupon.labels.code')"
                                :placeholder="$t('delivery.coupon.labels.code')"
                                :error="hasInputErrors('code')"
                                :error-messages="getInputErrors('code')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="text_ad"
                                name="description"
                                v-model="form.description"
                                :label="$t('delivery.coupon.labels.description')"
                                :placeholder="$t('delivery.coupon.labels.description')"
                                :error="hasInputErrors('description')"
                                :error-messages="getInputErrors('description')"
                                color="secondary"

                        ></v-text-field>
                    </v-col>


                   <v-col cols="12" sm="6">
                        <discount-type-combobox v-model="form.discountType" :input-errors="inputErrors" />
                   </v-col>


                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="payments"
                                name="discountValue"
                                v-model.number="form.discountValue"
                                type="number"
                                :label="$t('delivery.coupon.labels.discountValue')"
                                :placeholder="$t('delivery.coupon.labels.discountValue')"
                                :error="hasInputErrors('discountValue')"
                                :error-messages="getInputErrors('discountValue')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="mintmark"
                                name="minimumOrderAmount"
                                v-model.number="form.minimumOrderAmount"
                                type="number"
                                :label="$t('delivery.coupon.labels.minimumOrderAmount')"
                                :placeholder="$t('delivery.coupon.labels.minimumOrderAmount')"
                                :error="hasInputErrors('minimumOrderAmount')"
                                :error-messages="getInputErrors('minimumOrderAmount')"
                                color="secondary"

                        ></v-text-field>
                    </v-col>



          <v-col cols="12" sm="6">
            <v-text-field

                prepend-icon="numbers"
                name="maxTotalUses"
                v-model.number="form.maxTotalUses"
                type="number"
                :label="$t('delivery.coupon.labels.maxTotalUses')"
                :placeholder="$t('delivery.coupon.labels.maxTotalUses')"
                :error="hasInputErrors('maxTotalUses')"
                :error-messages="getInputErrors('maxTotalUses')"
                color="secondary"
                :rules="required"
            ></v-text-field>
          </v-col>


                   <v-col cols="12" sm="6">
                        <date-input
                            v-model="form.startDate"
                            :label="$t('delivery.coupon.labels.startDate')"
                            :error="hasInputErrors('startDate')"
                            :error-messages="getInputErrors('startDate')"
                            :rules="required"
                        />
                    </v-col>


                   <v-col cols="12" sm="6">
                        <date-input
                            v-model="form.expirationDate"
                            :label="$t('delivery.coupon.labels.expirationDate')"
                            :error="hasInputErrors('expirationDate')"
                            :error-messages="getInputErrors('expirationDate')"
                            :rules="required"
                        />
                    </v-col>



                    <v-col cols="12" sm="6">
                        <v-checkbox
                                prepend-icon="flash_on"
                                name="active"
                                v-model="form.active"
                                :label="$t('delivery.coupon.labels.active')"
                                :error="hasInputErrors('active')"
                                :error-messages="getInputErrors('active')"
                                color="secondary"

                        ></v-checkbox>
                    </v-col>

          <v-col cols="12" sm="6">
            <v-switch
                prepend-icon="payments"
                name="allowPaymentMethodDiscount"
                v-model="form.allowPaymentMethodDiscount"
                :label="$t('delivery.coupon.labels.allowPaymentMethodDiscount')"
                :error="hasInputErrors('allowPaymentMethodDiscount')"
                :error-messages="getInputErrors('allowPaymentMethodDiscount')"
                color="secondary"
            ></v-switch>
          </v-col>

          <v-col cols="12" sm="6">
            <payment-method-combobox v-model="form.paymentMethods" :input-errors="inputErrors" multiple chips />
          </v-col>

        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'


    import DiscountTypeCombobox from "../../combobox/DiscountTypeCombobox";
    import {DayjsMixin, DateInput} from "@dracul/dayjs-frontend";
    import PaymentMethodCombobox from "@/modules/delivery/combobox/PaymentMethodCombobox";



    export default {
        name: "CouponForm",
        mixins: [InputErrorsByProps, RequiredRule , DayjsMixin   ],
        components: {
          PaymentMethodCombobox,
          DiscountTypeCombobox,
          DateInput
        },
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            save(){
              this.$emit('save', this.form)
            }
        },
        data(){
            return {
                startDateDateMenu: false,
 expirationDateDateMenu: false
            }
        }
    }
</script>

<style scoped>

</style>
